import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Products } from "@/components/Products";
import { Process } from "@/components/Process";
import { Quality } from "@/components/Quality";
import { WhyUs } from "@/components/WhyUs";
import { Footprint } from "@/components/Footprint";
import { Engagement } from "@/components/Engagement";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <div className="noise-overlay" />
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <Services />
        <Products />
        <Process />
        <Quality />
        <WhyUs />
        <Footprint />
        <Engagement />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="light" richColors />
    </div>
  );
}

export default App;
